import { render, staticRenderFns } from "./VipJudgingPreview.vue?vue&type=template&id=46df1648&"
import script from "./VipJudgingPreview.vue?vue&type=script&lang=js&"
export * from "./VipJudgingPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports